import type { TTagOption } from '../../../packages/Tags/shared/types/tag';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDirection } from 'shared/types/geo';
import { ITags } from 'shared/types/tags';
import { IGeoTags } from 'shared/types/tags/geoTags';

export const initialState: ITags = {
  items: [],
  isHidden: false,
  meta: {
    geoTags: {} as IGeoTags,
    directions: [],
    undergroundsUnderConstruction: {},
    village: null,
    needUpdateGeoTags: false,
    coworkingNames: {},
  },
};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    removeAllTags: state => {
      state.items = [];
    },
    setTags: (state, action: PayloadAction<TTagOption[]>) => {
      state.items = action.payload;
    },
    setGeoTags: (state, action: PayloadAction<IGeoTags>) => {
      state.meta.geoTags = action.payload;
    },
    setDirections: (state, action: PayloadAction<IDirection[]>) => {
      state.meta.directions = action.payload;
    },
    setNeedUpdateGeoTags: (state, action: PayloadAction<boolean>) => {
      state.meta.needUpdateGeoTags = action.payload;
    },
    setCoworkingName: (state, action: PayloadAction<{ id: number; name: string }>) => {
      state.meta.coworkingNames[action.payload.id] = action.payload.name;
    },
    /**
     * Выставляет видимость тегов явно. Инверсии по умолчанию нет намеренно: потребитель
     * всегда знает нужное состояние, а транспорт микрофронтов не умеет передавать `false`
     * (в mf-registry payload проверяется на truthiness), и «выставить false» превращалось
     * бы в «инвертировать».
     */
    setTagsHidden: (state, action: PayloadAction<boolean>) => {
      state.isHidden = action.payload;
    },
  },
});

export const {
  name: tagsReducerName,
  reducer: tagsReducer,
  actions: { removeAllTags, setTags, setGeoTags, setDirections, setNeedUpdateGeoTags, setCoworkingName, setTagsHidden },
} = tagsSlice;
